// extracted by mini-css-extract-plugin
module.exports = {"layout":"ia","content":"ib","footer":"ic"};